@if (isLoaded) {
  <div>
    <div class="loading-section">
      <div class="margin-auto">
        <app-main-loader-lottie> </app-main-loader-lottie>
      </div>
    </div>
  </div>
} @else {
  <mat-drawer-container class="delivery-service-page">
    <mat-drawer #drawer mode="over" position="end" class="delivery-services__drawer">
      <div class="drawer">
        <app-side-drawer
          [drawer]="drawer"
          [shopId]="currentShopId"
          [currentCarrier]="currentCarrier"
          [isCreatingCarrier]="isCreatingCarrier">
        </app-side-drawer>
      </div>
    </mat-drawer>
    <div class="delivery-services__main_page">
      <div class="delivery-service-title-container">
        <div class="delivery-service-title" flexLayout="row">
          <div class="delivery-service-title-text">Delivery services</div>
          <div class="create-carrier-success">
            <app-create-carrier-notification
              [notificationText]="'Nice! New delivery service added.'"
              [notificationState]="notificationState">
            </app-create-carrier-notification>
          </div>
          <div class="add-carrier">
            <pdq-button
              (onClick)="openAddNewCarrierWindow()"
              [disabled]="isOnTrialPlan == true"
              icon="add_button"
              variant="primary"
              label="Add delivery service">
            </pdq-button>
          </div>
        </div>
      </div>
      <div class="delivery-services__main">
        <div class="delivery-services__main__content">
          @if ((carriers$ | async)?.length > 0) {
            <div>
              @for (carrier of carriers$ | async; track carrier) {
                <div class="delivery-services__list">
                  <span class="delivery-services__section__box0">
                    @if (carrier.haveInternalRatesCards && !carrier.isMasterCarrierAccount) {
                      <pdq-tag
                        class="carrier__rates-tag"
                        matTooltip="Some rates returned by this carrier are affected by a manually uploaded rate card."
                        matTooltipClass="pdq-mat-tooltip"
                        variant="quaternary"
                        size="small"
                        >Rates Uploaded</pdq-tag
                      >
                    }
                    @if (carrier.isTestMode) {
                      <pdq-tag variant="quaternary" size="small">Test mode</pdq-tag>
                    }
                    @if (!carrier.isTestMode && getIsExternalAuthenticationRequiredTooltip(carrier)) {
                      <pdq-tag variant="tertiary" size="small">
                        {{ getIsExternalAuthenticationRequiredTooltip(carrier) }}
                      </pdq-tag>
                    }
                    @if (isCarrierRequiresVerification(carrier)) {
                      <pdq-tag variant="tertiary" size="small">Verification Pending</pdq-tag>
                    }
                  </span>
                  <div class="delivery-services__section__box1">
                    <span
                      class="carrier__item-logo-container"
                      fxLayout="column"
                      fxLayoutAlign="center center"
                      fxLayoutGap="5px"
                      fxLayoutGap.xs="0">
                      <carrier-logo [carrierName]="carrier?.type?.name"></carrier-logo>
                      <p class="carrier-item-text">{{ carrier.name }}</p>
                    </span>
                  </div>
                  <div class="delivery-services__section__box3">
                    <div style="display: flex">
                      <pdq-slide-toggle
                        [defaultValue]="!!carrier.isActive"
                        (onToggle)="changeActiveCarrier($event, carrier)"
                        [disabled]="
                          isOnTrialPlan == true ||
                          getIsActiveTooltip(carrier).length > 0 ||
                          !isEditingEnabledForCarrier(carrier) ||
                          isCarrierRequiresExternalAuthentication(carrier) ||
                          isCarrierRequiresVerification(carrier)
                        ">
                      </pdq-slide-toggle>
                      @if (getIsActiveTooltip(carrier)) {
                        <img
                          style="margin-left: 10px"
                          src="assets/icons/icon-info.svg"
                          class="form-title-info-icon"
                          [matTooltip]="getIsActiveTooltip(carrier)"
                          matTooltipClass="pdq-mat-tooltip" />
                      }
                    </div>
                  </div>
                  <div class="delivery-services__delete-btn">
                    <app-list-drop-down
                      [imgSrc]="'assets/icons/3dots-menu.svg'"
                      [carrier]="carrier"
                      [isShowEditOption]="isEditingEnabledForCarrier(carrier)"
                      [isShowVerificationOption]="isCarrierRequiresVerification(carrier)"
                      (onActionEmit)="onDropDownAction($event)">
                    </app-list-drop-down>
                  </div>
                </div>
              }
            </div>
          }
          @if ((carriers$ | async)?.length === 0) {
            <div class="no-carriers">
              <div class="margin-auto">
                <img src="assets/images/delivery-service-cover.svg" alt="" />
                <div class="no-carriers__text">You haven’t added any delivery services yet</div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </mat-drawer-container>
}
